<template>
    <footer>
      <div class="container">
        <div class="logo">
            <router-link :to="{ name: 'home' }">
                <span>Mashup Web</span>
            </router-link>
        </div>
        <ul class="nav-footer">
            <li><router-link :to="{ name: 'about' }">{{ $t("home.nav.how-it-work") }}</router-link></li>
            <li><router-link :to="{ name: 'culture' }">{{ $t("home.nav.culture") }}</router-link></li>
            <li><router-link :to="{ name: 'contact' }">{{ $t("home.nav.contact") }}</router-link></li>
        </ul>
        <div class="partenaires">
          <div class="title">{{$t("home.footer.partners") }}</div>
          <ul>
            <li>
              <b-link target="_blank" href="https://www.caisse-epargne.fr/normandie/banque-normande/">
                <img alt="Caisse d'Epargne Normandie" src="../../assets/logo-caisse-epargne-100.jpg">
              </b-link>
            </li>
            <li>
              <b-link target="_blank" href="https://www.n-ci.com/start-up/waterstart-capital/">
                <img alt="Waterstart" src="../../assets/logo-waterstart-100.jpg">
              </b-link>
            </li>
            <li>
              <b-link target="_blank" href="https://www.bpifrance.fr/">
                <img alt="BPI France" src="../../assets/logo-bpi-100.jpg">
              </b-link>
            </li>
            <li>
              <b-link target="_blank" href="https://adnormandie.fr/">
                <img alt="AD Normandie" src="../../assets/logo-adn-100.jpg">
              </b-link>
            </li>
          </ul>
        </div>
        <ul class="copyright">
            <li style="order:2;">
              <ul>
                <li style="order:1;"><router-link :to="{ name: 'legal' }">{{ $t("home.footer.legal") }}</router-link></li>
              </ul>
            </li>
            <li style="order:1;">© 2020 Copyright Mashup Web</li>
        </ul>
      </div>
    </footer>
</template>

<script>

export default {
    name: 'Footer'
}    
</script>

<style scoped>
  footer {
   background: #020f13;
   text-align: center; 
   padding: 40px 25px;
   position: relative;
  }
  footer .container {
    position: relative;
  }
  footer .logo {
      display: inline-block;
      margin-bottom: 50px;
  }
  footer .logo a {
      display: flex;
      background: url(../../assets/logo.svg);
      background-size: 100%;
      width: 100px;
      height: 37px;
  }
  footer .logo a span {
      display: none;
  }
  footer ul li {
      font-size: 18px;
      font-weight: 500;
      line-height: 40px;
      margin-bottom: 10px;
  }
  footer .partenaires {
    padding-top: 38px;
    border-top: 2px solid rgba(255, 255, 255, 0.11);
    margin-top: 40px;
  }
  footer .partenaires .title {
    font-size: 18px;
    font-weight: 500;
    line-height: 40px;
  }
  footer .partenaires ul {
    flex-wrap: wrap;
    flex-direction: row;
    display: flex;
    /*position: absolute;
    top: 50px;
    right: 0;*/
    width: 300px;
    margin: auto;
    padding: 20px;
  }
  footer .partenaires ul li {
    margin-right: 20px;
  }
  footer .partenaires ul li:last-child {
    margin-right: 0;
  }
  footer .partenaires ul li img {
    width: 50px;
  }
  footer .copyright {
      color: #505a62;
      font-size: 18px;
      font-weight: normal;
      line-height: 40px;
      padding-top: 38px;
      border-top: 2px solid rgba(255, 255, 255, 0.11);
      margin-top: 30px;
  }
  footer .copyright a,
  footer .copyright a:hover {
    color: #505a62 !important;
    text-decoration: none;
  }

  /* desktop */

  @media (min-width: 1200px){
    footer ul.nav-footer {
      display: flex;
      justify-content: space-between;
      padding-bottom: 110px;
      margin: 0;
    }
    footer .logo {
      position: absolute;
      margin-bottom: 0;
      left: 15px;
      top: 110px;
    }
    
    footer .copyright,
    footer .copyright ul{
      padding-bottom: 0;
    }
    /*footer .copyright ul li {
      margin-left: 50px;
    }*/
  }
</style>